export const isPlaidOAuthRedirect = (): boolean =>
  typeof window !== "undefined" &&
  window.location.href.includes("?oauth_state_id=");
